import { useSelector } from "react-redux";
import { selectUserData } from "../../../features/userSlice";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import LeadsManagement from "../../../components/BizDevelopment/LeadsManagement/LeadsManagement";
import {
  LEADS_MANAGEMENT_SITE_NAME,
  userHasWebsiteAccess,
} from "../../../components/BizDevelopment/LeadsManagement/constants";
import { useWebsiteSharedUid } from "../../../customHooks/useWebsiteSharedUid";
export default function LeadsManagementScreen() {
  const userData = useSelector(selectUserData);
  const websiteSharedUid = useWebsiteSharedUid(LEADS_MANAGEMENT_SITE_NAME);
  const hasSiteAccess = userHasWebsiteAccess(
    userData,
    LEADS_MANAGEMENT_SITE_NAME,
  );
  const hasViewPermission = CheckPermissions(
    userData?.data?.products?.partners,
    "lead_managment",
    "view_lead_managment",
  );

  return hasSiteAccess && hasViewPermission && websiteSharedUid ? (
    <LeadsManagement websiteSharedUid={websiteSharedUid} />
  ) : (
    <Page404 />
  );
}
